import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_DYNAMIC_SPH = defineFcm('dynamic_sph')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-middle-end',
		context: 'Signed Petition Home',
		description:
			'Gates the dynamic_sph experiment (CHANGE-101607): on Signed Petition Home, the `enabled` arm renders the ' +
			'dynamic body with next-step modules instead of the static layout; `control` and `fake_control` keep the ' +
			'static layout. `experimentName` names the experiment-service experiment to bucket with, so a new ' +
			'iteration can be started without a deploy; it defaults to `dynamic_sph`. Off, every viewer sees the ' +
			'static layout and nobody is treated.',
		template: {
			enabled: true,
			experimentName: 'dynamic_sph',
		},
	});
